import { createSlice } from '@reduxjs/toolkit'
import IRestaurantInfo from 'models/IRestaurantInfo'
import IAnnouncement from 'models/IAnnouncement'

export interface RestaurantInfoState {
  isLoading: boolean
  isGetRestaurantInfoSuccess: boolean
  isGetAnnouncementSuccess: boolean
  isVisitSuccess: boolean
  restaurantInfo: IRestaurantInfo | null
  announcement: IAnnouncement | null
  visitResponseMessage: string | null
}

const initialState: RestaurantInfoState = {
  isLoading: false,
  isGetRestaurantInfoSuccess: false,
  isGetAnnouncementSuccess: false,
  isVisitSuccess: false,
  restaurantInfo: null,
  announcement: null,
  visitResponseMessage: null,
}

const restaurantInfoSlice = createSlice({
  name: 'restaurantInfo',
  initialState,
  reducers: {
    apiRequest: (state) => {
      state.isLoading = true
    },
    apiFailure: (state) => {
      state.isLoading = false
    },
    getRestaurantInfo(state, action) {
      state.isLoading = false
      state.isGetRestaurantInfoSuccess = true
      state.restaurantInfo = action.payload.restaurantInfo
    },
    getAnnouncement(state, action) {
      state.isLoading = false
      state.isGetAnnouncementSuccess = true
      state.announcement = action.payload.announcement
    },
    visit(state, action) {
      state.isLoading = false
      state.isVisitSuccess = action.payload.success
      state.visitResponseMessage = action.payload.message
    },
  },
})

export const {
  apiRequest,
  apiFailure,
  getRestaurantInfo,
  getAnnouncement,
  visit,
} = restaurantInfoSlice.actions
export default restaurantInfoSlice.reducer
